var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-flex',{attrs:{"mt":"30","flexDirection":"column","w":"100%","alignItems":"stretch"}},[_c('c-button',{attrs:{"disabled":_vm.disabled,"left-icon":_vm.icon,"variant-color":"blue"}},[_vm._v(_vm._s(_vm.menu))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }